import { AccountStoreService } from './account-store.service';
import { UserStoreService } from './user-store.service';
import { DeviceAddStoreService } from './device-add-store.service';
import { Injectable } from '@angular/core';
import { LicenseAddStoreService } from './license-add-store.service';

@Injectable({ providedIn: 'root' })
export class CleanService {

  constructor(private accountStoreService: AccountStoreService,
              private userStoreService: UserStoreService,
              private deviceAddStoreService: DeviceAddStoreService,
              private licenseAddStoreService: LicenseAddStoreService,
  ) {
  }

  clean(): void {
    this.accountStoreService.clean();
    this.userStoreService.clean();
    this.deviceAddStoreService.clean();
    this.licenseAddStoreService.clean();
  }

}
